import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const createLead = async (data) => {
  const res = await api.post("/leads", data);
  return res.data;
};

export const verifyPayment = async (leadId, paymentId) => {
  const body = leadId
    ? { lead_id: leadId, payment_id: paymentId }
    : { payment_id: paymentId };
  const res = await api.post("/payments/verify", body);
  return res.data;
};

export const fetchStats = async () => {
  const res = await api.get("/stats");
  return res.data;
};

export const buildDownloadUrl = (token) =>
  `${BACKEND_URL}/api/download/guide?token=${encodeURIComponent(token)}`;
